export default "__VITE_ASSET__C5m_nly5__"